<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center">
                <section class="mu-d-flex mu-flex-row mu-w-100">

                    <h1 class="mu-mb-00">Custom data List</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>

                </section>
                <section>

                    <div role="group" class="mcc-button-group">
                        <button class="mcc-button mcc-button--primary" id="createCustomDataListBtn" title="Create custom data list" @click="redirectToCrate()">
                            <mcc-icon name="plus" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Create custom data list</span>
                        </button>

                    </div>

                </section>
            </div>

        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <div>
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>Design</li>
                    <li>Custom data list</li>
                </ol>
            </nav>
        </div>
        <Drawer ref="customFilter" @reset-filter="resetFilter" @apply-filter="submitCustomDataList()" title="Custom Data Filters">
            <form id="formIdd">
            <div class="mfc-input-wrapper mfc-form-input-container drawer-input">
                <label for="name" class="mu-mb-00">Name</label>
                <input type="text" name="form-name" maxlength="50" id="name" :pattern="nameRegex" :value="dataListNameRef" @change="dataListNameRef = $event.target.value">

            </div>
            <div class="mcc-segmented-buttons mcc-segmented-buttons--sm drawer-input">
                <fieldset class="mfc-fieldset" aria-required="true" role="radiogroup" segmented help-text size="sm" block>
                    <legend class="mfc-label">Type</legend>
                    <div class="mcc-segmented-buttons__list" ref="radioRef" name="disabled-radioGroup" id="disabled-radioGroup">
                        <input id="Manual_radio_choice_button1" name="mfc-choice-button-group" type="radio" value="manual" @click="listTypeRef = $event.target.value" :checked="listTypeRef === 'manual'">
                        <label class="mcc-segmented-buttons__button" for="Manual_radio_choice_button1">

                            <span class="mcc-segmented-buttons__label"> Manual</span>

                        </label>
                        <input id="API_radio_choice_button2" name="mfc-choice-button-group" type="radio" value="eSys" @click="listTypeRef = $event.target.value" :checked="listTypeRef === 'eSys'">
                        <label class="mcc-segmented-buttons__button" for="API_radio_choice_button2">

                            <span class="mcc-segmented-buttons__label"> API</span>

                        </label>
                        <input id="All_radio_choice_button3" name="mfc-choice-button-group" type="radio" value=" " @click="listTypeRef = $event.target.value" :checked="listTypeRef === ' '">

                        <label class="mcc-segmented-buttons__button" for="All_radio_choice_button3">

                            <span class="mcc-segmented-buttons__label"> All</span>

                        </label>
                    </div>
                </fieldset>
            </div>
            <div class="mfc-slim-select-wrapper drawer-input">
                <label for="createdby-selectId ">Created by</label>
                <select class="mfc-slim-select" @change="selectedCreatedByRef = $event.target.value" ref="createdByRef" name="createdby-select" id="createdby-selectId" block>
                    <option data-placeholder="true" value=""></option>
                    <option v-for="(app,key) in userList" :selected="selectedCreatedByRef === app.username" :key="key" :value="app.username">{{app.firstName}}</option>

                </select>

            </div>

            <div class="mfc-slim-select-wrapper drawer-input">
                <label for="updateddby-selectId ">Last updated by</label>
                <select class="mfc-slim-select" @change="selectedUpdatedByRef = $event.target.value" ref="updatedByRef" name="updatedby-select" id="updateddby-selectId" block>
                    <option data-placeholder="true" value=""></option>
                    <option v-for="(app,key) in userList" :selected="selectedUpdatedByRef === app.username" :key="key" :value="app.username">{{app.firstName}}</option>

                </select>

            </div>

            <div class="flatpickr mfc-input-wrapper  drawer-input" ref="createdDate">
                <label for="inputGroupDefault1">Created between</label>
                <div class="mfc-input-group flatpickr-date--width mfc-input-group--has-help-text mfc-input-group--has-validation-text" id="CreatedateSelect">
                    <input type="text" placeholder="Select Date.." data-input="" ref="createdDateinput" name="createdDate" id="createdDateId" prepend icon="calendar" @change="handleStartRangeChange($event)" @ready="handleStartRangeReady()">
                    <button type="button" class="mcc-button mcc-button--outline mcc-button--icon-only" data-toggle="">
                        <mcc-icon aria-hidden="true" name="calendar"></mcc-icon>
                    </button>
                </div>
            </div>

            <div class="flatpickr mfc-input-wrapper   drawer-input" ref="updatedDate">
                <label for="inputGroupDefault1 mu-mb-00">Updated between</label>
                <div class="mfc-input-group flatpickr-date--width mfc-input-group--has-help-text mfc-input-group--has-validation-text" id="UpdatedateSelect">
                    <input type="text" placeholder="Select Date.." data-input="" ref="updatedDateInput" name="updatedDate" id="updatedDateId" prepend icon="calendar" @change="handleEndRangeChange($event)" @ready="handleEndRangeReady()">
                    <button type="button" class="mcc-button mcc-button--outline mcc-button--icon-only" data-toggle="">
                        <mcc-icon aria-hidden="true" name="calendar"></mcc-icon>
                    </button>
                </div>
            </div>
            </form>
        </Drawer>

                <div class="mcc-col">
                    <div style="position:relative">
                        <div v-if="!updateCall" class="spinner-overlay">
                            <div class="spinner-background"></div>
                            <div class="spinner-flex">
                                <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                    <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                </svg>
                            </div>
                        </div>
                        <div class="mcc-card">
                            <div class="mcc-card__body">
                                <div class="mu-d-flex mu-justify-content-end mu-pb-06">
                                    <button class="mcc-button mcc-button--outline  mcc-button--sm" @click="$refs.customFilter.open()">
                                        <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                        <span class="mcc-button__label">Filters {{ filterCount > 0 ? '(' + filterCount + ')' : '(1)' }}</span>
                                    </button>
                                </div>
                                <mcc-data-table ref="dataListTable" id="dataListTableId"></mcc-data-table>

                    </div>

                </div>
            </div>

        </div>
    </div>
</div>
</template>

<script>
import CustomDataListAPI from "../../../services/CustomDataListAPI";
import constantMessages from "../../../messages";
import Utils from "@/script_utils";
import MyProcessListAPI from "../../../services/MyProcessListAPI";
import Drawer from '../../common/Drawer.vue';
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';

export default {
    name: "CustomDataList",
    components: {
        Drawer,
    },
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["design.customdatalist.list"],
            nameRegex: constantMessages.PATTERNS["customName"],
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            processes: [],
            searchCriteria: {},
            applications: {},
            selectedCreatedByRef: "",
            selectedCreatedBy: "",
            selectedUpdatedByRef: "",
            selectedUpdatedBy: "",
            updateDialog: false,
            dataListName: "",
            listType: " ",
            dataListNameRef: "",
            listTypeRef: " ",
            selectedForm: [],
            createdDateRangeRef: [],
            updatedDateRangeRef: [],
            tableObj: null,
            currentPageSize: 10,
            createdFrom: "",
            createdTo: "",
            updatedFrom: "",
            updatedTo: "",
            userList: [],
            updateCall: true,
            tableData: [],
            filterActive: false,
            createdDateFlatPickrInstance: null,
            updatedDateFlatPickrInstance: null,
            createdBySlimSelectInstance: null,
            updatedBySlimSelectInstance: null,
            filterCount: 0,
        };
    },
    updated() {
        this.flatpickr()
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        if (localStorage.getItem("customDataList") === "customDataList") {
            this.listType = localStorage.getItem("DataTables_" + window.location.pathname + "_listType");
            if (this.listType == null) {
                this.listType = " ";
            }
            this.listTypeRef = this.listType;
            this.selectedCreatedBy = localStorage.getItem("DataTables_" + window.location.pathname + "_selectedCreatedBy");
            if (this.selectedCreatedBy == null) {
                this.selectedCreatedBy = "";
            }
            this.selectedCreatedByRef = this.selectedCreatedBy;
            this.selectedUpdatedBy = localStorage.getItem("DataTables_" + window.location.pathname + "_selectedUpdatedBy");
            if (this.selectedUpdatedBy == null) {
                this.selectedUpdatedBy = "";
            }
            this.selectedUpdatedByRef = this.selectedUpdatedBy;
            this.dataListName = localStorage.getItem("DataTables_" + window.location.pathname + "_dataListName");
            if (this.dataListName == null) {
                this.dataListName = "";
            }
            this.dataListNameRef = this.dataListName;
            if (localStorage.getItem("customDataListSize") != null) {
                this.currentPageSize = parseInt(localStorage.getItem("customDataListSize"));
            }
            localStorage.removeItem("customDataListSize");
            localStorage.removeItem("customDataList");
            localStorage.removeItem("DataTables_" + window.location.pathname + "_dataListName");
            localStorage.removeItem("DataTables_" + window.location.pathname + "_listType");
            localStorage.removeItem("DataTables_" + window.location.pathname + "_selectedCreatedBy");
            let updatedDateRangeStore = localStorage
                .getItem("DataTables_" + window.location.pathname + "_updatedDateRangeRef");
            if (updatedDateRangeStore != null && updatedDateRangeStore != "") {
                let updatedDateRangStringArr = updatedDateRangeStore
                    .split(",");
                if (updatedDateRangStringArr.length > 1) {
                    this.updatedDateRangeRef[0] = new Date(updatedDateRangStringArr[0]);
                    this.updatedDateRangeRef[1] = new Date(updatedDateRangStringArr[1]);
                }
            }
            let createdDateRangeStore = localStorage
                .getItem("DataTables_" + window.location.pathname + "_createdDateRangeRef");
            if (createdDateRangeStore != null && createdDateRangeStore != "") {
                let createdDateRangStringArr = createdDateRangeStore
                    .split(",");
                if (createdDateRangStringArr.length > 1) {
                    this.createdDateRangeRef[0] = new Date(createdDateRangStringArr[0]);
                    this.createdDateRangeRef[1] = new Date(createdDateRangStringArr[1]);
                }
            }
            localStorage.removeItem("DataTables_" + window.location.pathname + "_updatedDateRangeRef");
            localStorage.removeItem("DataTables_" + window.location.pathname + "_createdDateRangeRef");
            this.updateDateRef();
            localStorage.removeItem("customDataList");
        }
        this.createdBySlimSelectInstance = new SlimSelect({
            select: '#createdby-selectId',
        });
        this.updatedBySlimSelectInstance = new SlimSelect({
            select: '#updateddby-selectId',
        });
        this.flatpickr();
        MyProcessListAPI.getUsers().then(result => {
            this.userList = result;
        });
        this.initCustomDataListTable();
        this.updateTemplate();
    },
    methods: {
        resetSlimSelect() {
            this.createdBySlimSelectInstance.setSelected('')
            this.updatedBySlimSelectInstance.setSelected('')
        },
        flatpickr() {
            let self = this;

            self.createdDateFlatPickrInstance = flatpickr(this.$refs.createdDate, {
                dateFormat: 'd/M/Y',
                altInput: true,
                wrap: true,
                altFormat: 'd/m/Y',
                mode: 'range',
                defaultDate: [self.createdDateRangeRef[0], self.createdDateRangeRef[1]],
            });
            self.updatedDateFlatPickrInstance = flatpickr(this.$refs.updatedDate, {
                dateFormat: 'd/M/Y',
                altInput: true,
                wrap: true,
                altFormat: 'd/m/Y',
                mode: 'range',
                defaultDate: [self.updatedDateRangeRef[0], self.updatedDateRangeRef[1]],
            });
        },
        getFilterCount() {
            if (this.dataListNameRef != "")
                this.filterCount += 1
            if (this.listTypeRef != "")
                this.filterCount += 1
            if (this.selectedCreatedByRef != "")
                this.filterCount += 1
            if (this.selectedUpdatedByRef != "")
                this.filterCount += 1
            if (this.createdFrom != "")
                this.filterCount += 1
            if (this.updatedFrom != "")
                this.filterCount += 1

        },
        resetFilter() {
            this.updateCall = false;
            this.listTypeRef = " ";
            this.selectedCreatedByRef = "";
            this.selectedUpdatedByRef = "";
            this.selectedUpdatedBy = "";
            this.dataListNameRef = "";
            this.selectedCreatedBy = "";
            this.dataListName = "";
            this.listType = " ";
            this.createdFrom = "";
            this.createdTo = "";
            this.updatedFrom = "";
            this.updatedTo = "";
            this.updatedDateRangeRef = [];
            this.createdDateRangeRef = [];
            flatpickr("#createdDateId").destroy();
            flatpickr("#updatedDateId").destroy();
            this.flatpickr();
            this.resetSlimSelect();
            localStorage.clear();
            localStorage.setItem("showedBPMTour", "true");
            this.filterCount = 0;
            this.getFilterCount();
            this.initCustomDataListTable();
            this.updateTemplate();
        },
        submitCustomDataList() {
            let form = $('#formIdd')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            this.updateDateRef();
            this.filterCount = 0;
            this.getFilterCount();
            this.selectedCreatedBy = this.selectedCreatedByRef;
            this.selectedUpdatedBy = this.selectedUpdatedByRef;
            this.dataListName = this.dataListNameRef;
            this.listType = this.listTypeRef;
            this.initCustomDataListTable();
            this.updateTemplate();
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")
        },
        showCopy() {
            return this.selectedForm.length > 0;
        },
        updateTemplate() {
            let self = this;
            this.$refs.dataListTable
                .querySelectorAll('td [class="table-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            self.setFilterDataInLocalStorage();
                            let reference = $(targetEle).attr("data-id");
                            self.$router.push(self.CONTEXT_PATH + "/design/customDataList/" + reference.trim());
                        }
                    });
                });
        },
        initCustomDataListTable() {
            let self = this;
            self.selectedForm = [];
            if (this.tableObj != null) {
                this.currentPageSize = this.tableObj.tableContext.store.state.pageSize;
            }
            const filesTable = document.querySelector('#dataListTableId');
            this.tableObj = window.tableFactory.create(filesTable, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No data lists found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                debounceTime: 1000,
                schema: {
                    properties: {
                        name: {
                            type: "string",
                            title: "Name",
                            template: '<a class="table-link" data-id="{{id}}">{{name}}</a>',
                            sortable: true
                        },
                        created: {
                            type: "string",
                            title: "Created",
                            template: '<div class="dateTemplate"><u>{{prettyCreatedTime}}</u><div>{{createdString}}</div></div>',
                            sortable: true
                        },
                        createdBy: {
                            type: "string",
                            title: "Created by",
                            sortable: true
                        },
                        prettyLastUpdatedTime: {
                            type: "string",
                            title: "Last updated",
                            template: '<div class="dateTemplate"><u>{{prettyLastUpdatedTime}}</u><div>{{lastUpdatedString}}</div></div>',
                            sortable: true
                        },
                        lastUpdatedBy: {
                            type: "string",
                            title: "Last updated by",
                            sortable: true
                        },
                        type: {
                            type: "string",
                            title: "Type",
                            sortable: true
                        }
                    }
                },
                data: (start, limit, sortHeader, sortDirection, fullTextQuery, searchColumns) => {
                    if (!self.filterActive) {
                        self.updateCall = false;
                        if (self.tableObj != null) {
                            self.currentPageSize =
                                self.tableObj.tableContext.store.state.pageSize;
                        }
                        if (sortHeader == null) {
                            sortHeader = "name";
                        }
                        if (sortDirection == null) {
                            sortDirection = "asc";
                        }
                        if (sortHeader == "prettyLastUpdatedTime") {
                            sortHeader = "lastUpdated";
                        }
                        let queryString = "start=" +
                            start +
                            "&length=" +
                            self.currentPageSize +
                            "&sort=" +
                            sortHeader +
                            "&dir=" +
                            sortDirection +
                            "&name=" +
                            self.dataListName +
                            "&createdBy=" +
                            encodeURI(self.selectedCreatedBy) + "&updatedBy=" + encodeURI(self.selectedUpdatedBy);
                        if (self.createdFrom != null && self.createdFrom != "") {
                            queryString += "&startDateCreated=" +
                                self.createdFrom + "&endDateCreated=" + self.createdTo;
                        }
                        if (self.updatedFrom != null && self.updatedFrom != "") {
                            queryString += "&startDateUpdated=" +
                                self.updatedFrom + "&endDateUpdated=" + self.updatedTo;
                        }
                        if (self.listType.trim() != "") {
                            queryString += "&type=" +
                                self.listType.trim();
                        }
                        return CustomDataListAPI.getCustomDataList(queryString).then(result => {
                            let responseData = {
                                totalCount: 0,
                                data: []
                            };
                            responseData.totalCount = result.page.totalElements;
                            if (result.data != null) {
                                result.data.forEach(resultField => {
                                    resultField.select =
                                        self.selectedForm.indexOf(resultField.id) != -1;
                                    resultField['createdString'] = resultField['created'] != null ?
                                        Utils.getMomentDateString(resultField['created']) : '';
                                    resultField['lastUpdatedString'] = resultField['lastUpdated'] != null ?
                                        Utils.getMomentDateString(resultField['lastUpdated']) : '';
                                });
                                responseData.data = result.data;
                            }
                            self.updateCall = true;
                            self.tableData = responseData.data;
                            return responseData;
                        });
                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        return responseData;
                    }
                },
                onAfterDataLoad: (start, limit) => {
                    self.updateTemplate();
                }
            });
        },

        handleStartRangeChange(e) {
            this.createdDateRangeRef = "";
            if (e.target.value.length > 1) {
                this.createdDateRangeRef = e.target.value.split(' to ');
            }
        },
        handleEndRangeChange(e) {
            this.updatedDateRangeRef = "";
            if (e.target.value.length > 1) {
                this.updatedDateRangeRef = e.target.value.split(' to ');
            }
        },
        handleEndRangeReady() {
            if (this.updatedDateRangeRef.length > 1) {
                this.$refs.updatedDate.value =
                    moment(this.updatedDateRangeRef[0]).format("DD/MM/YYYY") +
                    " to " +
                    moment(this.updatedDateRangeRef[1]).format("DD/MM/YYYY");
            }
        },
        redirectToCrate() {
            this.setFilterDataInLocalStorage();
            this.$router.push(this.CONTEXT_PATH + "/design/customDataList/new");
        },
        updateDateRef() {
            let self = this;
            this.createdFrom = "";
            this.createdTo = "";
            this.updatedFrom = "";
            this.updatedTo = "";
            if (self.createdDateRangeRef.length > 0) {
                let createdDateFrom = self.createdDateRangeRef[0];
                let createdDateTo = self.createdDateRangeRef[1];
                let d = new Date(createdDateFrom);
                d.setHours(0, -d.getTimezoneOffset(), 0, 0);
                this.createdFrom = d.toISOString();
                if (!createdDateTo) {
                    createdDateTo = createdDateFrom
                }
                d = new Date(createdDateTo);
                d.setHours(23, -d.getTimezoneOffset() + 59, 59, 999);
                this.createdTo = d.toISOString();
            }
            if (self.updatedDateRangeRef.length > 0) {
                let updatedDateFrom = self.updatedDateRangeRef[0];
                let updatedDateTo = self.updatedDateRangeRef[1];
                let d = new Date(updatedDateFrom);
                d.setHours(0, -d.getTimezoneOffset(), 0, 0);
                this.updatedFrom = d.toISOString();
                if (!updatedDateTo) {
                    updatedDateTo = updatedDateFrom
                }
                d = new Date(updatedDateTo);
                d.setHours(23, -d.getTimezoneOffset() + 59, 59, 999);
                this.updatedTo = d.toISOString();
            }
        },
        setFilterDataInLocalStorage() {
            localStorage.setItem("DataTables_" + window.location.pathname + "_listType", this.listType);
            localStorage.setItem("DataTables_" + window.location.pathname + "_selectedCreatedBy", this.selectedCreatedBy);
            localStorage.setItem("DataTables_" + window.location.pathname + "_dataListName", this.dataListName);
            localStorage.setItem("DataTables_" + window.location.pathname + "_updatedDateRangeRef", this.updatedDateRangeRef);
            localStorage.setItem("DataTables_" + window.location.pathname + "_createdDateRangeRef", this.createdDateRangeRef);
            localStorage.setItem("DataTables_" + window.location.pathname + "_selectedUpdatedBy", this.selectedUpdatedBy);
        }
    },

};
</script>

<style scoped>
.flatpickr-calendar {
    top: 2%;
}

.mfc-input-group input[readonly] {
    color: black !important;
}

.flatpickr-date--width>.numInput.cur-year {
    width: auto !important;
}

#createCustomDataListBtn {
    text-wrap: nowrap;
}
</style>
